module.exports = __webpack_public_path__ + "img/Magnifier.c0e9fb0c.svg";